export default "/assets/images/update-hero-img.png?7204dc1e2d372c3964b4b83800c16b7d";